import React, { useState, useEffect } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from './../components/modules/errors/ErrorsPage'
import { AuthPage } from './../components/modules/auth/AuthPage'
import { Logout } from './../components/modules/auth/Logout'
import './../scss/style.scss'
import { AuthApp } from 'src/AuthApp'
import AuthService from 'src/components/modules/auth/redux/AuthService'

const AppRoutes = () => {

  
  const [isAuthorized, setIsAuthorized] = useState(false)
  const usr = AuthService.GetCurrentUser();

  useEffect(() => {  

    if(usr && usr.token && usr.userData && usr.userData.sessionGuid ){
      setIsAuthorized(true)
    }
   
  }, [usr])
    
    return (
      <BrowserRouter>
        <Routes>
          <Route element={<AuthApp />}>
            <Route path='error/*' element={<ErrorsPage />} />
            <Route path='logout' element={<Logout />} />
            {!isAuthorized ? (
              <>

                <Route path='auth/*' element={<AuthPage />} />
                <Route path='*' element={<Navigate to='/auth' />} />
              </>
            ) : (
              <>
                <Route name='dashboard' path='/*' element={<PrivateRoutes />} />
                <Route name='dashboard' index element={<Navigate to='/dashboard' />} />
              </>
            )}
          </Route>
        </Routes>
      </BrowserRouter>
    )
}
export { AppRoutes }